import { ApiRequestModel } from "../api_request_model";
import { BaseClass } from "../master/mastermodel";

export class ResendOTPRequest extends BaseClass {
  public ActorOTPRequestCode: number;
  public OTPActivationCode: string;
 // public SendApiRequestModel: ApiRequestModel;
}
export class ConfirmOTPRequest extends BaseClass {
  public ActorOTPRequestCode: number;
  public OTPActivationCode: string;
 // public SendApiRequestModel: ApiRequestModel;
}

